import { DownloadIcon } from 'src/components/ui-icons/upload';
import { exportExcelSummary } from '../../utils/export-excel';
import { DirectionsRequirement, UniversalObject } from '../../types/data';
import { TooltipItem } from "src/utils/Tooltip";

type ExportExcelSummaryProps = {
  data: DirectionsRequirement[];
  params: {
    year: number,
    group: UniversalObject,
    factory: UniversalObject,
    gop: UniversalObject
  }
}

function ExportExcelSummary({ data, params }: ExportExcelSummaryProps) {
  return (
    <TooltipItem position="top" tooltipsText={'Экспорт в Excel'}>
      <button
        className="rounded-md bg-white p-4 shadow-md h-full"
        type="button"
        onClick={() => exportExcelSummary(data, params)}>
        <DownloadIcon />
      </button>
    </TooltipItem>
  )
}

export default ExportExcelSummary;
